<template lang="pug">
  ul.my-gallery.lista(v-if="images.length")
    li.item(v-for="image of images", :key="image.id")
      a(:href="image.url"): img(:src="image.url", alt="", :title="image.title", class="my-album")
  .loading-container.galeria-loading(v-else)
    span.sr-only Carregando...
    each val in [1, 2, 3, 4]
      .item
        .cover.animated
</template>

<script>
  import $ from 'jquery/src/jquery'

  export default{
    props: {
      images: { type: Array, required: true }
    },
    mounted () {
      try {
        $('.my-gallery a').simpleLightbox()
      } catch (e) {}
    }
  }
</script>

<style>
  .my-gallery a img {
/*    float: left;
    width: 20%;
    height: auto;
    border: 2px solid #fff;
    -webkit-transition: -webkit-transform .15s ease;
    -moz-transition: -moz-transform .15s ease;
    -o-transition: -o-transform .15s ease;
    -ms-transition: -ms-transform .15s ease;
    transition: transform .15s ease;
    position: relative;*/
  }
  .my-gallery a:hover img {
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -o-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05);
    z-index: 5;
  }
 .my-gallery a.big img {
    width: 40%;
  }

  .align-center {
    text-align: center;
  }

  @import url('https://fonts.googleapis.com/css?family=Ruda');

</style>



// WEBPACK FOOTER //
// GaleriaAlbum.vue?9bacc970